export default function PHP_array_walk() {
  return (
    <div>
      <h1>PHP_array_walk</h1>
    </div>
  );
}
